import React from 'react';
import { IframeWrapper } from 'modules/backstage-content/IframeWrapper';
import { useAccount } from 'modules/taboola-common-frontend-modules/account-configurations';
import { useFormFieldValue } from 'modules/taboola-common-frontend-modules/formData';
import { usePublishedVersionNumber } from '../../hooks/usePublishedVersionNumber';
import { getLandingPageUrl } from '../../utils/getLandingPageUrl';
import styles from './previewSection.module.scss';

const Placeholder = () => {
    return <div className={styles.placeholder} />;
};

export const PreviewSection = ({ className, iframeClassName }) => {
    const { id: numericAccountId } = useAccount();
    const { value: updatedAt } = useFormFieldValue({ field: 'updatedAt' });
    const { value: navigationTimestamp } = useFormFieldValue({ field: 'navigationTimestamp' });
    const { value: slug } = useFormFieldValue({ field: 'slug' });
    const { value: status } = useFormFieldValue({ field: 'status' });
    const { value: landingPageId } = useFormFieldValue({ field: 'landingPageId' });
    const { value: versionNumber } = useFormFieldValue({ field: 'versionNumber' });
    const { value: totalVersions } = useFormFieldValue({ field: 'totalVersions' });

    const publishedVersionNumber = usePublishedVersionNumber();
    let page = '';

    if (numericAccountId && slug) {
        page = getLandingPageUrl({
            accountId: numericAccountId,
            slug,
            status,
            isPreview: true,
            landingPageId,
            versionNumber,
            totalVersions,
            publishedVersionNumber,
        });
    }

    // Use navigation timestamp if available (for version navigation), otherwise use updatedAt
    const cacheBuster = navigationTimestamp || Date.parse(updatedAt);

    return (
        <div className={className}>
            {slug ? (
                <IframeWrapper
                    className={iframeClassName}
                    title="landing page preview"
                    src={`${page}&timestamp=${cacheBuster}`}
                />
            ) : (
                <Placeholder />
            )}
        </div>
    );
};
